export const Constants = {
    Notification: {
        Type: [
            { id: 1, name: "Hoş geldin" },
            { id: 2, name: "Yeni talep geldi" },
        ]
    },
    User: {
        Type: [
            { id: 1, name: "Öğrenci" },
            { id: 2, name: "Danışman Adayı" },
            { id: 3, name: "Danışman" },
            { id: 4, name: "Eğitmen" },
        ]
    },
    Contact: {
        State: [
            { id: 1, name: "Okunmadı" },
            { id: 2, name: "Okundu" },
            { id: 3, name: "Dönüş Yapıldı" },
            { id: 4, name: "Ulaşılamadı" },
            { id: 5, name: "Geri Dönüş Yapılmadı" },
            { id: 6, name: "İptal Edildi" }
        ],
        Subject: [
            "Yardım ve Bilgi Edinme",
            "Şikayet ve İtiraz",
            "Öneri ve Tavsiye",
            "Bilgi Değişikliği",
            "Paket ve Ödeme",
            "Teknik Destek",
            "Diğer Konular",
        ],
    },
    Contract: {
        Period: [
            { id: 30, name: "Aylık" },
            { id: 90, name: "3 Aylık" },
            { id: 120, name: "6 Aylık" },
            { id: 365, name: "Yıllık" },
        ]
    },
    Package: {
        Type: [
            { id: 1, name: "Eğitmen Eğitimleri" },
            { id: 2, name: "Yükseköğretim Kurumları Sınavı" },
            { id: 3, name: "Liselere Geçiş Sistemi" },
            { id: 4, name: "YKS Tercih Danışmanlığı" },
            { id: 5, name: "LGS Tercih Danışmanlığı" },
            { id: 6, name: "Canlı Ders" },
            { id: 7, name: "Kamu Personel Seçme Sınavı" },
        ],
        State: [
            { id: 1, name: "Beklemede" },
            { id: 2, name: "Ödeme Aşamasında" },
            { id: 3, name: "Ödendi" },
            { id: 4, name: "Hata Oluştu" },
            { id: 5, name: "İptal Edildi" },
            { id: 6, name: "İade Edildi" },
            { id: 7, name: "Üye İptal Etti" },
        ],
        Period: [
            { id: -1, name: "Sınırsız" },
            { id: 0, name: "Tek Seferlik" },
            { id: 30, name: "Aylık" },
            { id: 60, name: "2 Aylık" },
            { id: 90, name: "3 Aylık" },
            { id: 120, name: "6 Aylık" },
            { id: 365, name: "Yıllık" },
        ]
    },
    Payment: {
        Type: [
            { id: 1, name: "Kredi Kartı" },
            { id: 2, name: "Havale-Eft" },
        ]
    },
    Question: {
        Answer: [
            { id: 0, name: "Cevabı Bilmiyorum!" },
            { id: 1, name: "A" },
            { id: 2, name: "B" },
            { id: 3, name: "C" },
            { id: 4, name: "D" },
            { id: 5, name: "E" }
        ],
        Type: [
            { id: 1, name: "Genel" },
            { id: 2, name: "Paragraf" },
            { id: 3, name: "Hesaplama" },
            { id: 4, name: "Check-Up" },
            { id: 5, name: "Tarama" },
            { id: 6, name: "Dikkat İşlem" },
            { id: 7, name: "Mikro İşlem" },
            { id: 8, name: "Makro İşlem" },
        ],
        Difficulty: [
            { id: 1, name: "Kolay" },
            { id: 2, name: "Orta" },
            { id: 3, name: "Zor" },
        ]
    },
    Test: {
        Type: [
            { id: 1, name: "Check-Up" },
            { id: 2, name: "Tarama" },
        ],
        Difficulty: [
            { id: 1, name: "Kolay" },
            { id: 2, name: "Orta" },
            { id: 3, name: "Zor" },
        ]
    },
    ResourceBook: {
        Type: [
            { id: 2, name: "Soru Bankası" },
            { id: 1, name: "Konu Anlatım" },
            { id: 3, name: "Deneme" },
        ],
        Difficulty: [
            { id: 1, name: "Kolay" },
            { id: 2, name: "Orta" },
            { id: 3, name: "Zor" },
        ]
    },
    Meeting: {
        Type: [
            { id: 3, name: 'Danışmanlık' },
            { id: 4, name: 'Canlı Ders' }
        ],
        Server: [
            { id: 1, name: "Google Meet" },
            { id: 2, name: "Zoom" },
            { id: 3, name: "Agora" }
        ],
        State: [
            { id: 1, name: "Beklemede" },
            { id: 2, name: "Yapıldı" },
            { id: 3, name: "Ertelendi" },
            { id: 4, name: "Danışman Müsait Değil" },
            { id: 5, name: "Öğrenci Müsait Değil" },
            { id: 6, name: "Sistemsel Hata" },
        ],
        Question: [
            { id: 1, name: "Öğretmenin Sunduğu İmkanlar" },
            { id: 2, name: "Neden Özel Ders Veriyorum" },
            { id: 3, name: "Tecrübelerim" },
            { id: 4, name: "Size Neler Kazandırabilirim" },
            { id: 5, name: "Dersleri Nasıl İşlerim" },
            { id: 6, name: "Özel Ders Almak İsteyenlere Tavsiyeler" },
        ]
    },
    Interview: {
        State: [
            { id: 1, name: "Beklemede" },
            { id: 2, name: "Yapıldı" },
            { id: 3, name: "Yapılmadı" },
            { id: 4, name: "Olumlu" },
            { id: 5, name: "Olumsuz" },
        ],
        Result: [
            { id: 1, name: "Beklemede" },
            { id: 2, name: "İncelendi" },
            { id: 3, name: "Değerlendirilebilir" },
            { id: 4, name: "Geri Dönüş Yapıldı" },
            { id: 5, name: "Geri Dönüş Yapılmadı" },
            { id: 6, name: "Ulaşılamadı" },
        ],
    },
    Trial: {
        Type: [
            { id: 1, name: "Genel" },
            { id: 2, name: "Alan" },
            { id: 3, name: "Branş" },
        ],
        WrongType: [
            { id: 1, name: "Okuma/İşlem Hatası" },
            { id: 2, name: "Konu Eksikliği" },
            { id: 3, name: "Yetiştirememek" },

            //{ id: 1, name: "Yanlış Okuma" },
            //{ id: 2, name: "İşlem Hatası" },
            //{ id: 3, name: "Kavram Karıştırma" }, // Konu Eksikliği
            //{ id: 4, name: "Üst Üste Çözmek" }, // Yetiştirememek
            //{ id: 5, name: "Konu Eksikliği" },
            //{ id: 6, name: "Yetiştirememek" },
            //{ id: 7, name: "İşlemedim" }, // Konu Eksikliği
        ],
        EmptyType: [
            { id: 1, name: "Okuma/İşlem Hatası" },
            { id: 2, name: "Konu Eksikliği" },
            { id: 3, name: "Yetiştirememek" },

            //{ id: 1, name: "Yanlış Okuma" },
            //{ id: 2, name: "İşlem Hatası" },
            //{ id: 3, name: "Kavram Karıştırma" }, // Konu Eksikliği
            //{ id: 4, name: "Üst Üste Çözmek" }, // Yetiştirememek
            //{ id: 5, name: "Konu Eksikliği" }, 
            //{ id: 6, name: "Yetiştirememek" },
            //{ id: 7, name: "İşlemedim" }, // Konu Eksikliği
        ],
    },
    Routine: {
        Type: [
            {
                "id": 1,
                "name": "P Merdiven",
                "detail": "Öğrenciyi düşünsel olarak adım adım yönlendiren bir stratejidir. 'Merdiven' öğrenme basamaklarını simgeler; 'P' harfi genellikle problem veya paragraf anlamında kullanılır."
            },
            {
                "id": 2,
                "name": "Çöz Analiz",
                "detail": "Bir metni ya da durumu parçalarına ayırarak incelemeyi ve her parçayı değerlendirmeyi içeren düşünme tekniğidir."
            },
            {
                "id": 3,
                "name": "Paragraf Çözme",
                "detail": "Paragraftaki ana fikri, yardımcı düşünceleri ve yazarın amacı gibi unsurları çözümlemeye yönelik bir okuma stratejisidir."
            },
            {
                "id": 4,
                "name": "Kavramsallaştırma",
                "detail": "Kavramlar veya fikirler arasındaki ilişkileri görsel olarak düzenleme yöntemidir. Kavram haritası ya da zihin haritası ile uygulanır."
            },
            {
                "id": 5,
                "name": "Oku-Anlat",
                "detail": "Önceki notların tekrar edilip üstüne kısa özet notlarla anlatılmaya çalışılması ve anlatılamayan yerlerin tekrar edilmesidir."
            },
            {
                "id": 6,
                "name": "Özetleme",
                "detail": "Metni kendi ifadelerinle kısa ve öz şekilde yeniden yazma tekniğidir. Anlama ve hatırlamayı geliştirir."
            },
            {
                "id": 7,
                "name": "Görev",
                "detail": ""
            },
        ],
        TestType: [
            { id: 0, name: "-" },
            { id: 1, name: "SÇV + 1 Test" },
            { id: 2, name: "1 Test" },
            { id: 3, name: "2 Test" },
            { id: 4, name: "3 Test" },
            { id: 5, name: "4 Test" },
            { id: 6, name: "5 Test" },
            { id: 6, name: "5 Test" },
            { id: 7, name: "Soru" },
        ]
    },
    LiveEducation: {
        Lesson: [
            { id: 1, name: "Matematik" },
            { id: 2, name: "Türkçe" },
            { id: 3, name: "Fizik" },
            { id: 4, name: "Kimya" },
            { id: 5, name: "Biyoloji" },
            { id: 6, name: "İngilizce" },
            { id: 7, name: "Edebiyat" },
            { id: 8, name: "Geometri" },
            { id: 9, name: "Tarih" }
        ],
        Gender: [
            { id: 1, name: "Erkek" },
            { id: 2, name: "Kadın" }
        ],
        Level: [
            { id: 13, name: "LGS Hazırlık" },
            { id: 14, name: "YKS (TYT AYT) Hazırlık" },
            { id: 15, name: "Önlisans - Lisans Düzeyi" },
            { id: 16, name: "DGS, KPSS, ALES Hazırlık" },
            { id: 17, name: "Okul Öncesi" },
            { id: 18, name: "Yetişkinler İçin Ders" },
            { id: 19, name: "Matematik Olimpiyatlarına Hazırlık" },
            { id: 20, name: "İB Sınavlarına Hazırlık" },
            { id: 21, name: "Diğer" },
            { id: 1, name: "1. Sınıf" },
            { id: 2, name: "2. Sınıf" },
            { id: 3, name: "3. Sınıf" },
            { id: 4, name: "4. Sınıf" },
            { id: 5, name: "5. Sınıf" },
            { id: 6, name: "6. Sınıf" },
            { id: 7, name: "7. Sınıf" },
            { id: 8, name: "8. Sınıf" },
            { id: 9, name: "9. Sınıf" },
            { id: 10, name: "10. Sınıf" },
            { id: 11, name: "11. Sınıf" },
            { id: 12, name: "12. Sınıf" },
        ],
    },
    File: {
        Type: [
            { id: 1, name: "Pdf" },
            { id: 2, name: "Video" },
        ]
    },
    Send: {
        State: [
            { id: 1, name: "Beklemede" },
            { id: 2, name: "Gönderildi" },
            { id: 3, name: "Hata Oluştu" },
        ],
    },
    Setting: {
        MinPastYear: "min_past_year",
        MaxPastYear: "max_past_year",
        Lang: [
            { id: 1, name: "Türkçe", main: true }
        ],
        TimeZone: "+03:00",
        DateFormat: "dd.MM.yyyy",
        TimeFormat: "HH:mm:ss",
        Days: [
            { id: 1, name: "Pazartesi" },
            { id: 2, name: "Salı" },
            { id: 3, name: "Çarşamba" },
            { id: 4, name: "Perşembe" },
            { id: 5, name: "Cuma" },
            { id: 6, name: "Cumartesi" },
            { id: 7, name: "Pazar" },
        ],
    },
    Date: {
        DayList: [
            { id: 1, name: "Pazartesi" },
            { id: 2, name: "Salı" },
            { id: 3, name: "Çarşamba" },
            { id: 4, name: "Perşembe" },
            { id: 5, name: "Cuma" },
            { id: 6, name: "Cumartesi" },
            { id: 7, name: "Pazar" },
        ],
        DaySortList: [
            { id: 1, name: "Pzt" },
            { id: 2, name: "Sal" },
            { id: 3, name: "Çar" },
            { id: 4, name: "Per" },
            { id: 5, name: "Cum" },
            { id: 6, name: "Cmt" },
            { id: 7, name: "Paz" },
        ],
        MonthList: [
            { id: 1, name: "Ocak" },
            { id: 2, name: "Şubat" },
            { id: 3, name: "Mart" },
            { id: 4, name: "Nisan" },
            { id: 5, name: "Mayıs" },
            { id: 6, name: "Haziran" },
            { id: 7, name: "Temmuz" },
            { id: 8, name: "Ağustos" },
            { id: 9, name: "Eylül" },
            { id: 10, name: "Ekim" },
            { id: 11, name: "Kasım" },
            { id: 12, name: "Aralık" },
        ],
        MonthSortList: [
            { id: 1, name: "Oca" },
            { id: 2, name: "Şub" },
            { id: 3, name: "Mar" },
            { id: 4, name: "Nis" },
            { id: 5, name: "May" },
            { id: 6, name: "Haz" },
            { id: 7, name: "Tem" },
            { id: 8, name: "Ağu" },
            { id: 9, name: "Eyl" },
            { id: 10, name: "Eki" },
            { id: 11, name: "Kas" },
            { id: 12, name: "Ara" },
        ],
    },
    Mood: {
        List: [
            { id: 1, name: "Yorgun", img: "/assets/img/emoji/tired-emoji.png" },
            { id: 2, name: "Kaygılı", img: "/assets/img/emoji/worried-emoji.png" },
            { id: 3, name: "Üzgün", img: "/assets/img/emoji/sad-emoji.png" },
            { id: 4, name: "Durgun", img: "/assets/img/emoji/stagnant-emoji.png" },
            { id: 5, name: "Mutlu", img: "/assets/img/emoji/happy-emoji.png" },
            { id: 6, name: "Rahat", img: "/assets/img/emoji/relaxed-emoji.png" },
            { id: 7, name: "Heyecanlı", img: "/assets/img/emoji/excited-emoji.png" },
        ],
    },
    Color: {
        List: ["turkish", "math", "science", "social-studies", "primary"],
    },
    Page: {
        Orientation: [
            { id: false, name: "Dikey" },
            { id: true, name: "Yatay" },
        ],
        List: [
            { id: "A4", name: "A4", width: 210, height: 297 },
            { id: "10 x 15 cm", name: "10 x 15 cm", width: 102, height: 154 },
            { id: "13 x 18 cm", name: "13 x 18 cm", width: 127, height: 178 },
            { id: "A6", name: "A6", width: 105, height: 148 },
            { id: "A5", name: "A5", width: 148, height: 210 },
            { id: "B5", name: "B5", width: 182, height: 257 },
            { id: "9 x 13 cm", name: "9 x 13 cm", width: 89, height: 127 },
            { id: "13 x 20 cm", name: "13 x 20 cm", width: 127, height: 203 },
            { id: "20 x 25 cm", name: "20 x 25 cm", width: 203, height: 254 },
            { id: "Letter #10 4 1/8 x 9 1/2 in", name: "Letter #10 4 1/8 x 9 1/2 in", width: 104, height: 241 },
            { id: "Letter DL", name: "Letter DL", width: 110, height: 220 },
            { id: "Letter C6", name: "Letter C6", width: 114, height: 162 },
            { id: "Letter 8 1/2 x 11 in", name: "Letter 8 1/2 x 11 in", width: 216, height: 280 },
            { id: "Legal 8 1/2 x 14 in", name: "Legal 8 1/2 x 14 in", width: 216, height: 356 },
            { id: "A3", name: "A3", width: 297, height: 420 },
            { id: "A3+", name: "A3+", width: 329, height: 483 },
            { id: "B4", name: "B4", width: 257, height: 364 },
            { id: "B3", name: "B3", width: 364, height: 515 }
        ]
    }, 
    Bank: [{ "name": "Adabank A.\u015e.", "address": "B\u00fcy\u00fckdere Cad. Rumelihan No 40 Kat 2 Mecidiyek\u00f6y \u0130stanbul", "telephone": "212-2726420", "fax": "212-2726446", "web": "http:\/\/www.adabank.com.tr", "telex": "27282 adb TR", "eft": "0100", "swift": "ADABTRIS" }, { "name": "Akbank T.A.\u015e.", "address": "Sabanc\u0131 Center 4. Levent \u0130stanbul", "telephone": "212-3855555", "fax": "212-2697383", "web": "http:\/\/www.akbank.com", "telex": "26449 aktc TR", "eft": "0046", "swift": "AKBKTRIS" }, { "name": "Aktif Yat\u0131r\u0131m Bankas\u0131 A.\u015e.", "address": "B\u00fcy\u00fckdere Cad. No 163 Zincirlikuyu \u015ei\u015fli \u0130stanbul", "telephone": "212-3408000", "fax": "212-3408987", "web": "http:\/\/www.aktifbank.com.tr", "telex": null, "eft": "0143", "swift": "CAYTTRIS" }, { "name": "Alternatifbank A.\u015e.", "address": "Cumhuriyet Caddesi No. 46 Elmada\u011f \u015ei\u015fli \u0130stanbul", "telephone": "212-3156500", "fax": "212-2331500", "web": "http:\/\/www.abank.com.tr", "telex": "26191 ALFBTRIS", "eft": "0124", "swift": "ALFBTRIS" }, { "name": "Anadolubank A.\u015e.", "address": "Cumhuriyet Mah. Silah\u015f\u00f6r Cad. No 69 Bomonti \u015ei\u015fli \u0130stanbul", "telephone": "212-3687000", "fax": "212-2965715", "web": "http:\/\/www.anadolubank.com.tr", "telex": null, "eft": "0135", "swift": "ANDLTRIS" }, { "name": "Arap T\u00fcrk Bankas\u0131 A.\u015e.", "address": "Valikona\u011f\u0131 Cad. No 10 Ni\u015fanta\u015f\u0131 \u0130stanbul", "telephone": "212-225050020", "fax": "212-22505262249992", "web": "http:\/\/www.atbank.com.tr", "telex": "26830 atbk TR", "eft": "0091", "swift": "ATUBTRIS" }, { "name": "Bank Mellat", "address": "B\u00fcy\u00fckdere Cad. Binbir\u00e7i\u00e7ek Sok. No 1 1.Levent \u0130stanbul", "telephone": "212-2798015", "fax": "212-28462142846657", "web": "http:\/\/www.mellatbank.com", "telex": "26502 melt TR", "eft": "0094", "swift": "BKMTTRIS" }, { "name": "Bank of Tokyo-Mitsubishi UFJ Turkey A.\u015e.", "address": "Fatih Sultan Mehmet Mahallesi, Poligon Caddesi Buyaka 2 Sitesi No: 8B C-Blok, Kat: 20-21 Tepe\u00fcst\u00fc \u00dcmraniye \u0130stanbul", "telephone": "216-6003000", "fax": "216-2906473", "web": "http:\/\/www.tu.bk.mufg.jp", "telex": null, "eft": "0147", "swift": "BOTKTRIS" }, { "name": "BankPozitif Kredi ve Kalk\u0131nma Bankas\u0131 A.\u015e.", "address": "R\u00fczgarl\u0131bah\u00e7e Mah. Kay\u0131n Sok. No.3 Kavac\u0131k Beykoz \u0130stanbul", "telephone": "216-5382525", "fax": "216-5384258", "web": "http:\/\/www.bankpozitif.com.tr", "telex": null, "eft": "0142", "swift": "BPTRTRIS" }, { "name": "Birle\u015fik Fon Bankas\u0131 A.\u015e.", "address": "B\u00fcy\u00fckdere Cad. No 143 Kat 1-2 Esentepe \u015ei\u015fli \u0130stanbul", "telephone": "212-3401000", "fax": "212-3473217", "web": "http:\/\/www.fonbank.com.tr", "telex": "27920 dev TR", "eft": "0029", "swift": "BAYDTRIS" }, { "name": "Burgan Bank A.\u015e.", "address": "Esentepe Mah. B\u00fcy\u00fckdere Cad. No 209, Tekfen Tower, \u015ei\u015fli \u0130stanbul", "telephone": "212-3713737", "fax": "212-3714242", "web": "http:\/\/www.burgan.com.tr", "telex": null, "eft": "0125", "swift": "TEKFTRIS" }, { "name": "Citibank A.\u015e.", "address": "Saray Mahallesi \u00d6mer Faik Atakan Caddesi, No 3 Y\u0131lmaz Plaza \u00dcmraniye \u0130stanbul", "telephone": "216-5245000", "fax": "216-5245050", "web": "http:\/\/www.citibank.com.tr", "telex": "26277 citi TR", "eft": "0092", "swift": "CITITRIX" }, { "name": "Denizbank A.\u015e.", "address": "B\u00fcy\u00fckdere Cad. No 141 Esentepe \u015ei\u015fli \u0130stanbul", "telephone": "212-3482000", "fax": "212-3363030", "web": "http:\/\/www.denizbank.com", "telex": null, "eft": "0134", "swift": "DENITRIS" }, { "name": "Deutsche Bank A.\u015e.", "address": "Esentepe Mah. B\u00fcy\u00fckdere Cad. Tekfen Tower, No 209 K:17-18 \u015ei\u015fli \u0130stanbul", "telephone": "212-3170100", "fax": "212-3170105", "web": "http:\/\/www.db.com.tr", "telex": "39343 tmch tr.", "eft": "0115", "swift": "BKTRTRIS" }, { "name": "Diler Yat\u0131r\u0131m Bankas\u0131 A.\u015e.", "address": "Tersane Cad. No 96 Diler Han Kat 8 Karak\u00f6y \u0130stanbul", "telephone": "212-2536630", "fax": "212-2539454", "web": "http:\/\/www.dilerbank.com.tr", "telex": null, "eft": "0138", "swift": "DYAKTRIS" }, { "name": "Fibabanka A.\u015e.", "address": "Emirhan Caddesi Barbaros Plaza  Merkezi No 113 Dikilita\u015f  Be\u015fikta\u015f \u0130stanbul", "telephone": "212-3818200", "fax": "212-2583778", "web": "http:\/\/www.fibabanka.com.tr", "telex": null, "eft": "0103", "swift": "FBHLTRIS" }, { "name": "Finans Bank A.\u015e.", "address": "Esentepe Mah. B\u00fcy\u00fckdere Cad. Kristal Kule Binas\u0131 No 215 \u015ei\u015fli \u0130stanbul", "telephone": "212-3185000", "fax": "212-3185850", "web": "http:\/\/www.finansbank.com.tr", "telex": "398242 fnb tr", "eft": "0111", "swift": "FNNBTRIS" }, { "name": "GSD Yat\u0131r\u0131m Bankas\u0131 A.\u015e.", "address": "Ayd\u0131nevler Mah. Kaptan R\u0131fat Sokak. No 3 GSD Binas\u0131 No 14 K\u00fc\u00e7\u00fckyal\u0131  Maltepe \u0130stanbul", "telephone": "216-5879000", "fax": "216-4899774", "web": "http:\/\/www.gsdbank.com.tr", "telex": null, "eft": "0139", "swift": "GSDBTRIS" }, { "name": "Habib Bank Limited", "address": "Abide-i H\u00fcrriyet Cad. Ge\u00e7it Sok. No 6\/A \u015ei\u015fli \u0130stanbul", "telephone": "212-24602202460223", "fax": "212-2340807", "web": "http:\/\/www.habibbank.com.tr", "telex": "27849 hbl TR", "eft": "0097", "swift": "HABBTRIS" }, { "name": "HSBC Bank A.\u015e.", "address": "Esentepe Mah. B\u00fcy\u00fckdere Cad. No 128 \u015ei\u015fli \u0130stanbul", "telephone": "212-3764000", "fax": "212-3362939", "web": "http:\/\/www.hsbc.com.tr", "telex": "38385 mdn TR", "eft": "0123", "swift": "HSBCTRIX" }, { "name": "ING Bank A.\u015e.", "address": "Re\u015fitpa\u015fa Mahallesi Eski B\u00fcy\u00fckdere Cad. No 8 Sar\u0131yer \u0130stanbul", "telephone": "212-3351000", "fax": "212-2866100", "web": "http:\/\/www.ingbank.com.tr", "telex": null, "eft": "0099", "swift": "INGBTRIS" }, { "name": "Intesa Sanpaolo S.p.A.", "address": "Meltem Sokak, No: 10  Kuleleri, Kule 2,Kat: 21 Levent Be\u015fikta\u015f \u0130stanbul", "telephone": "212-3850600", "fax": "212-3850649", "web": "http:\/\/www.intesasanpaolo.com.tr", "telex": null, "eft": "0148", "swift": "BCITTRIS" }, { "name": "\u0130ller Bankas\u0131 A.\u015e.", "address": "Ziraat Mah. 657 Sok. No 14 D\u0131\u015fkap\u0131 Ankara", "telephone": "312-50870003033000", "fax": "312-50873993107459", "web": "http:\/\/www.ilbank.gov.tr", "telex": "42723 gnmd tr", "eft": "0004", "swift": "" }, { "name": "\u0130stanbul Takas ve Saklama Bankas\u0131 A.\u015e.", "address": "\u015ei\u015fli Merkez Mahallesi, Merkez Caddesi, No 6 \u015ei\u015fli \u0130stanbul", "telephone": "212-3152525", "fax": "212-3152526", "web": "http:\/\/www.takasbank.com.tr", "telex": null, "eft": "0132", "swift": "TVSBTRIS" }, { "name": "JPMorgan Chase Bank N.A.", "address": "B\u00fcy\u00fckdere Cad. No 185 Kanyon Ofis Binas\u0131 Kat 8 Levent \u0130stanbul", "telephone": "212-3198500", "fax": "212-3198664", "web": "http:\/\/www.jpmorgan.com\/pages\/international\/turkey", "telex": "26625 cmb TR", "eft": "0098", "swift": "CHASTRIS" }, { "name": "Merrill Lynch Yat\u0131r\u0131m Bank A.\u015e.", "address": "B\u00fcy\u00fckdere Cad. No 185 Kanyon Ofisi Blo\u011fu 11. Kat Levent \u0130stanbul", "telephone": "212-3199500", "fax": "212-3199511", "web": "http:\/\/www.mlyb.com.tr", "telex": "25849 tayb TR", "eft": "0129", "swift": "MEYYTRISXXX" }, { "name": "Nurol Yat\u0131r\u0131m Bankas\u0131 A.\u015e.", "address": "Maslak Mah. B\u00fcy\u00fckdere Cad. Nurol Plaza No 257 B Blok, Kat 15 Maslak  \u015ei\u015fli \u0130stanbul", "telephone": "212-2868100", "fax": "212-2868101", "web": "http:\/\/www.nurolbank.com.tr", "telex": null, "eft": "0141", "swift": "NUROTRIS" }, { "name": "Odea Bank A.\u015e.", "address": "Levent 199, B\u00fcy\u00fckdere Cad. No 199, Kat 33-39 \u015ei\u015fli \u0130stanbul", "telephone": "212-3048444", "fax": "212-3048445", "web": "http:\/\/www.odeabank.com.tr", "telex": null, "eft": "0146", "swift": "ODEATRIS" }, { "name": "Pasha Yat\u0131r\u0131m Bankas\u0131 A.\u015e.", "address": "Maslak Mah. A.O.S. 55. Sok. No 2 42 Maslak Ofis 3 Kat 7 Daire 205 Sar\u0131yer \u0130stanbul", "telephone": "212-7058900", "fax": "212-3450712", "web": "http:\/\/www.pashabank.com.tr", "telex": "26475 yatb TR", "eft": "0116", "swift": "TAIBTRIS" }, { "name": "Rabobank A.\u015e.", "address": "Esentepe Mah. B\u00fcy\u00fckdere Cad. Bahar Sok. River Plaza No: 13 K: 7 Ofis No:15-16 \u015ei\u015fli \u0130stanbul", "telephone": "212-7084600", "fax": "212-7084699", "web": "http:\/\/www.rabobank.com.tr", "telex": null, "eft": "0137", "swift": "RABOTRIS" }, { "name": "Soci\u00e9t\u00e9 G\u00e9n\u00e9rale (SA)", "address": "Nispetiye Cad. Akmerkez E-3 Blok Kat 10 Etiler \u0130stanbul", "telephone": "212-3193400", "fax": "212-28218482821844", "web": "http:\/\/www.sgcib.com.tr", "telex": "SOGETRIS", "eft": "0122", "swift": "SOGETRIS" }, { "name": "Standard Chartered Yat\u0131r\u0131m Bankas\u0131 T\u00fcrk A.\u015e.", "address": "B\u00fcy\u00fckdere Cad. Yap\u0131 Kredi Plaza, C Blok, Kat 15 Levent \u0130stanbul", "telephone": "212-3393700", "fax": "212-2826301", "web": "http:\/\/www.standardchartered.com.tr", "telex": null, "eft": "0121", "swift": "BSUITRIS" }, { "name": "\u015eekerbank T.A.\u015e.", "address": "B\u00fcy\u00fckdere Caddesi No 171 Metrocity A- Blok Esentepe  Mecidiyek\u00f6y \u0130stanbul", "telephone": "212-3197000", "fax": "212-3197429", "web": "http:\/\/www.sekerbank.com.tr", "telex": "46990 skgm- TR eker TR", "eft": "0059", "swift": "SEKETR2A" }, { "name": "Tekstil Bankas\u0131 A.\u015e.", "address": "Maslak Mah. Dereboyu\/2 Cad. No 13 Sar\u0131yer \u0130stanbul", "telephone": "212-3355335", "fax": "212-3281328", "web": "http:\/\/www.tekstilbank.com.tr", "telex": "39381 tbak TR", "eft": "0109", "swift": "TEKBTRIS" }, { "name": "The Royal Bank of Scotland Plc.", "address": "Tamburi Ali Efendi Sok. No 13 Etiler Be\u015fikta\u015f \u0130stanbul", "telephone": "212-3594040", "fax": "212-3595050", "web": "http:\/\/www.rbsbank.com.tr", "telex": "24677 hbu TR", "eft": "0088", "swift": "ABNATRIS" }, { "name": "Turkish Bank A.\u015e.", "address": "Vali Kona\u011f\u0131 Cad. No 1 Ni\u015fanta\u015f\u0131 \u015ei\u015fli \u0130stanbul", "telephone": "212-3736373", "fax": "212-225035355", "web": "http:\/\/www.turkishbank.com.tr", "telex": "27359 tbl\u0131 TR", "eft": "0096", "swift": "TUBATRIS" }, { "name": "Turkland Bank A.\u015e.", "address": "19 May\u0131s Mah. 19 May\u0131s Cad. \u015ei\u015fli Plaza A Blok No 7 \u015ei\u015fli \u0130stanbul", "telephone": "212-3683434", "fax": "212-3683535", "web": "http:\/\/www.tbank.com.tr", "telex": "25461-25462", "eft": "0108", "swift": "TBNKTRIS" }, { "name": "T\u00fcrk Ekonomi Bankas\u0131 A.\u015e.", "address": "TEB Kamp\u00fcs C ve D Blok Saray Mah. Sokullu Cad. No. 7A-7B 34768 \u00dcmraniye \u0130stanbul", "telephone": "216-6353535", "fax": "216-6363636", "web": "http:\/\/www.teb.com.tr", "telex": "25358 tebu TR", "eft": "0032", "swift": "TEBUTRIS" }, { "name": "T\u00fcrk Eximbank", "address": "Saray Mahallesi Ahmet Tevfik \u0130leri Cad. No 19 \u00dcmraniye \u0130stanbul", "telephone": "216-6665500", "fax": "216-6665599", "web": "http:\/\/www.eximbank.gov.tr", "telex": "46751 exmb TR", "eft": "0016", "swift": "TIKBTR2A" }, { "name": "T\u00fcrkiye Cumhuriyeti Ziraat Bankas\u0131 A.\u015e.", "address": "Anafartalar Mah. Atat\u00fcrk Bulvar\u0131 No 8 Alt\u0131nda\u011f Ankara", "telephone": "312-5842000", "fax": "312-5842551", "web": "http:\/\/www.ziraatbank.com.tr", "telex": "44004 zbhm TR", "eft": "0010", "swift": "TCZBTR2A" }, { "name": "T\u00fcrkiye Garanti Bankas\u0131 A.\u015e.", "address": "Nispetiye Mah. Aytar Cad. No 2 Levent Be\u015fikta\u015f \u0130stanbul", "telephone": "212-3181818", "fax": "212-3181888", "web": "http:\/\/www.garanti.com.tr", "telex": "27635 gat\u0131 TR", "eft": "0062", "swift": "TGBATRIS" }, { "name": "T\u00fcrkiye Halk Bankas\u0131 A.\u015e.", "address": "Barbaros Mahallesi, \u015eebboy Sokak No:4 Ata\u015fehir \u0130stanbul", "telephone": "216-5037070", "fax": "212-3409399", "web": "http:\/\/www.halkbank.com.tr", "telex": "TRHBTR2A", "eft": "0012", "swift": "TRHBTR2A" }, { "name": "T\u00fcrkiye \u0130\u015f Bankas\u0131 A.\u015e.", "address": "Kuleleri Levent Be\u015fikta\u015f \u0130stanbul", "telephone": "212-3160000", "fax": "212-3160900-05", "web": "http:\/\/www.isbank.com.tr", "telex": "42082 tab TR", "eft": "0064", "swift": "ISBKTRIS" }, { "name": "T\u00fcrkiye Kalk\u0131nma Bankas\u0131 A.\u015e.", "address": "Necatibey Caddesi, No 98 Yeni\u015fehir Ankara", "telephone": "312-2318400312-2313125", "fax": "312-2313125", "web": "http:\/\/www.kalkinma.com.tr", "telex": "43206 turb-TR", "eft": "0017", "swift": "TKBNTR2A" }, { "name": "T\u00fcrkiye S\u0131nai Kalk\u0131nma Bankas\u0131 A.\u015e.", "address": "Meclisi Mebusan Cad. No 81 F\u0131nd\u0131kl\u0131 \u0130stanbul", "telephone": "212-3345050", "fax": "212-3345234", "web": "http:\/\/www.tskb.com.tr", "telex": "24344 tskb TR", "eft": "0014", "swift": "TSKBTRIS" }, { "name": "T\u00fcrkiye Vak\u0131flar Bankas\u0131 T.A.O.", "address": "Sanayi Mahallesi Eski B\u00fcy\u00fckdere Caddesi G\u00fcler Sokak No: 51 Ka\u011f\u0131thane \u0130stanbul", "telephone": "2123981515-2123981000", "fax": "2123981155", "web": "http:\/\/www.vakifbank.com.tr", "telex": "46023 vbho-tr", "eft": "0015", "swift": "TVBATR2A" }, { "name": "Yap\u0131 ve Kredi Bankas\u0131 A.\u015e.", "address": "Yap\u0131 Kredi Plaza D Blok Levent \u0130stanbul", "telephone": "212-3397000", "fax": "212-3396000", "web": "http:\/\/www.yapikredi.com.tr", "telex": "931002 ykge TR", "eft": "0067", "swift": "YAPITRISFEX" }],
};